import { render, staticRenderFns } from "./co-broker-search-step.vue?vue&type=template&id=fa35f45e&scoped=true"
import script from "./co-broker-search-step.vue?vue&type=script&lang=js"
export * from "./co-broker-search-step.vue?vue&type=script&lang=js"
import style0 from "./co-broker-search-step.vue?vue&type=style&index=0&id=fa35f45e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa35f45e",
  null
  
)

export default component.exports